import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as ReactAutosuggest from 'react-autosuggest';
import * as Fuse from 'fuse.js';
import { debounce } from 'lodash';

const MIN_CHARS_BEFORE_SUGGEST = 2;

// When suggestion is clicked, Autosuggest needs to populate the input
// based on the clicked suggestion. Teach Autosuggest how to calculate the
// input value for every given suggestion.
const getSuggestionValue = suggestion => suggestion;

// Use your imagination to render suggestions.
const renderSuggestion = suggestion => (
  <div>
    {suggestion}
  </div>
);

class AutoSuggestInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      suggestions: [],
    };

    this.fuse = this.setupFuse();

    this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);

    if (this.props.disableDebounce) {
      this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    } else {
      this.onSuggestionsFetchRequested = debounce(this.onSuggestionsFetchRequested.bind(this), 100);
    }
    this.getSuggestions = this.getSuggestions.bind(this);
  }

  onSuggestionsFetchRequested({ value }) {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested() {
    this.setState({
      suggestions: [],
    });
  }

  setupFuse() {
    const options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 20,
      maxPatternLength: 32,
      minMatchCharLength: 1,
    };

    return new Fuse(this.props.list, options);
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions(value) {
    if (value.length < MIN_CHARS_BEFORE_SUGGEST) {
      return [];
    }

    const results = this.fuzzySearch(value);
    return results.map(index => this.props.list[index]);
  }

  fuzzySearch(value) {
    return this.fuse.search(value);
  }

  render() {
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      value: this.props.value,
    };

    return (
      <div>
        <ReactAutosuggest
          suggestions={this.state.suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={Object.assign(inputProps, this.props.inputProps)}
        />
      </div>
    );
  }
}

AutoSuggestInput.propTypes = {
  value: PropTypes.string,
  list: PropTypes.array,
  inputProps: PropTypes.object,
  disableDebounce: PropTypes.bool,
};

export default AutoSuggestInput;



// WEBPACK FOOTER //
// ./javascripts/components/listing_form/auto_suggest_input.jsx